/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CircleIcon, CheckmarkCircleIcon } from '@glu/icons-react/lib';
import useStyles from './ImportTypeCheckbox.styles';

const ImportTypeCheckboxComponent = ({
  data: { icon, label, onClick },
  disableCheckboxes,
  disableMultiselect,
  highlightBorder,
  onSelect,
  selectedCheckboxes
}) => {
  const classes = useStyles();

  const onToggleSelect = useCallback(() => {
    let selectedData = [];

    if (disableMultiselect) {
      selectedData = selectedCheckboxes.includes(label) ? [] : [label];

      if (onClick) {
        onClick({ label, selectedData });
      }
      return onSelect(selectedData);
    }

    selectedData = selectedCheckboxes.includes(label)
      ? [...selectedCheckboxes.filter((item) => item !== label)]
      : [...selectedCheckboxes, label];

    if (onClick) {
      onClick({ label, selectedData });
    }

    return onSelect(selectedData);
  }, [selectedCheckboxes, disableMultiselect, onSelect, label, onClick]);

  const isSelected = useMemo(
    () => selectedCheckboxes.includes(label),
    [selectedCheckboxes, label]
  );

  const checkMark = useMemo(() => {
    if (disableCheckboxes) return null;

    return !isSelected ? <CircleIcon /> : <CheckmarkCircleIcon />;
  }, [isSelected, disableCheckboxes]);

  return (
    <div
      className={classnames(
        'col-sm-3 no-gutters',
        classes.wrapper,
        highlightBorder && isSelected ? 'highlighted' : ''
      )}
      data-qa={label}
      onClick={onToggleSelect}
    >
      <span className={classes.checkmark}>{checkMark}</span>
      <div className={classes.body}>
        <div className={classes.iconWrapper}>{icon}</div>
        <span className={classes.label}>{label}</span>
      </div>
    </div>
  );
};

ImportTypeCheckboxComponent.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string,
    icon: PropTypes.oneOfType([PropTypes.node]),
    onClick: PropTypes.func
  }),
  onSelect: PropTypes.func,
  highlightBorder: PropTypes.bool,
  disableCheckboxes: PropTypes.bool,
  disableMultiselect: PropTypes.bool,
  selectedCheckboxes: PropTypes.arrayOf(PropTypes.shape({}))
};

ImportTypeCheckboxComponent.defaultProps = {
  data: {
    label: '',
    icon: null,
    onClick() {}
  },
  onSelect() {},
  highlightBorder: false,
  disableCheckboxes: false,
  disableMultiselect: false,
  selectedCheckboxes: []
};

export default ImportTypeCheckboxComponent;
